import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @class reportsActionHandler
 *
 * (trs) this component acts as a gatekeeper between the report action buttons
 * and the report action modal. there are certain actions (just 'Approved' for
 * now) that require precursory prompts/actions to be taken before the modal
 * should appear. in use with report detail and reports index.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { getIsPermittedWithAnyOfThesePermissions } from '../common/classes/permissions';
import entityComposition from '../common/classes/entityComposition';
class ReportsActionHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: false,
      userCanEditIssues: getIsPermittedWithAnyOfThesePermissions(['issue_admin', 'issue_reviewer'])
    };
    this.handleApprove = this.handleApprove.bind(this);
    this.saveIssues = this.saveIssues.bind(this);
  }

  /* eslint-disable react/sort-comp, camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const currentAction = this.props.currentAction;
    const nextAction = nextProps.currentAction,
      issues = nextProps.issues;

    // The action type was just changed to Approve
    if (nextAction === 'Approve' && currentAction !== 'Approve') {
      this.handleApprove(issues);
      // The action was changed to anything but Approve
    } else if (nextAction !== 'Approve' && nextAction !== null && currentAction !== nextAction) {
      this.handleApprove([]);
      // The action was cleared
    } else if (nextAction === null) {
      this.setState({
        showChildren: false
      });
    }
  }

  /**
   * @method handleApprove
   * @param issues (array)
   * prompt user with the choice to change status of all issues, continue
   * without changes, or cancel.
   */
  handleApprove(issues) {
    const userCanEditIssues = this.state.userCanEditIssues;
    if (!userCanEditIssues || !issues.length) {
      this.setState({
        showChildren: true
      });
      return;
    }
    const _this$props = this.props,
      onCancel = _this$props.onCancel,
      notificationActions = _this$props.notificationActions;
    notificationActions.info({
      headerMessage: "This report contains ".concat(issues.length, " open Issues."),
      message: 'Would you like to change their status to \'Reviewed\'?',
      leftButtonAction: () => {
        this.setState({
          showChildren: true
        });
        this.saveIssues(issues);
      },
      leftButtonLabel: 'Change All',
      middleButtonAction: () => {
        this.setState({
          showChildren: true
        });
      },
      middleButtonLabel: 'Change None',
      rightButtonAction: () => {
        if (onCancel) {
          onCancel();
        }
      },
      rightButtonLabel: 'Cancel',
      // allows only one notification of this kind at a time
      id: 'handle_open_issues'
    }, {
      // we need to run `onCancel` events when dismissing, and we need user interaction
      autoClose: false,
      closeButton: false
    });
  }

  /**
   * @method saveIssues
   * @param issues (array)
   * if the reports have issues, return all any who do not have a
   * reviewed or closed status
   */
  saveIssues(issues) {
    const _this$props2 = this.props,
      issueStatus = _this$props2.issueStatus,
      issueActions = _this$props2.issueActions;
    // get the Reviewed IssueStatus object from store
    const statuses = issueStatus.list;
    const newStatus = _.where(statuses, {
      identifier: 'reviewed'
    })[0];

    // prepare the issue merge patches for saving
    // "status": {
    //   "open": {
    //     "title": "Open",
    //     "_created": 1
    //   }
    // },
    const mergePatches = issues.map(issue => {
      const content = JSON.parse(issue.content);
      const _Object$keys = Object.keys(content.status),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        statusIdentifier = _Object$keys2[0];
      return {
        entity: 'issue',
        id: issue.id,
        patch: {
          status: {
            [newStatus.identifier]: {
              title: newStatus.name,
              _created: newStatus.sortOrder
            },
            [statusIdentifier]: null
          }
        }
      };
    });
    // save the issues
    issueActions.serverSaveAllMergePatches(mergePatches);
  }
  render() {
    const showChildren = this.state.showChildren;
    const _this$props3 = this.props,
      issues = _this$props3.issues,
      children = _this$props3.children,
      currentAction = _this$props3.currentAction;
    return /*#__PURE__*/React.createElement("div", null,
    // @NOTE (trs) in most use-cases, the child provided to this
    // component is the reportActionModal.
    (showChildren || issues.length === 0) && currentAction ? children : undefined);
  }
}
ReportsActionHandler.defaultProps = {
  currentAction: null,
  children: null
};
ReportsActionHandler.propTypes = {
  children: PropTypes.node,
  currentAction: PropTypes.string,
  issueActions: PropTypes.shape({
    serverSaveAll: PropTypes.func,
    serverSaveAllMergePatches: PropTypes.func
  }).isRequired,
  issues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  issueStatus: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired
};
export { ReportsActionHandler as TestReportsActionHandler };
export default entityComposition(ReportsActionHandler, ['report', 'issueStatus'], {}, ['issue', 'notification']);